import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function RoleField({ role, setRole, className }) {
  return (
    <>
      <div className={classNames('form-radio', className)}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className={classNames('form-radio-label')}>
          <input
            name="role"
            type="radio"
            value="student"
            required
            checked={role === 'student'}
            onChange={(e) => setRole(e.target.checked && e.target.value)}
            className={classNames('form-radio-input')}
          />
          Student
        </label>
      </div>
      <div className={classNames('form-radio', className)}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className={classNames('form-radio-label')}>
          <input
            name="role"
            type="radio"
            value="teacher"
            required
            checked={role === 'teacher'}
            onChange={(e) => setRole(e.target.checked && e.target.value)}
            className={classNames('form-radio-input')}
          />
          Educator
        </label>
      </div>
      <div className={classNames('form-radio', className)}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className={classNames('form-radio-label')}>
          <input
            name="role"
            type="radio"
            value="parent"
            required
            checked={role === 'parent'}
            onChange={(e) => setRole(e.target.checked && e.target.value)}
            className={classNames('form-radio-input')}
          />
          Parent/Caregiver
        </label>
      </div>
    </>
  );
}

RoleField.propTypes = {
  role: PropTypes.string.isRequired,
  setRole: PropTypes.func.isRequired,
  className: PropTypes.string,
};

RoleField.defaultProps = {
  className: null,
};

export default RoleField;
